import React from 'react';
import { TableCell, TableRow } from '@mui/material';

interface PurchaseHistoryRowProps {
  order: any;
}

const PurchaseHistoryRow: React.FC<PurchaseHistoryRowProps> = ({ order }) => {
  return (
    <TableRow>
      <TableCell>{order.id}</TableCell>
      <TableCell>{new Date(order.createdAt).toLocaleDateString()}</TableCell>
      <TableCell>{order.totalPrice}</TableCell>
      <TableCell>
        {order.lineItems.map((item: any) => (
          <div key={item.title}>
            {item.title} - {item.quantity} pcs @ {item.price}
          </div>
        ))}
      </TableCell>
      <TableCell>{order.customer?.email || 'N/A'}</TableCell>
    </TableRow>
  );
};

export default PurchaseHistoryRow;
